import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, ShieldCheck, CreditCard, Lock, XCircle, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-slate-50" data-id="element-31">
      {/* SECTION 1 - HERO */}
      <section className="relative pt-4 sm:pt-20 pb-10 sm:pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto overflow-hidden" data-id="element-32">
        <div className="relative z-10 flex flex-col items-center text-center" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center w-full" data-id="element-34">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-800 font-semibold text-xs sm:text-sm mb-2 sm:mb-6" data-id="element-35">
              <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-36"></span>
              PROFE LISTO · PADEL 360
            </div>

            <h1 className="text-[26px] leading-[1.05] sm:text-6xl lg:text-7xl font-heading font-bold text-slate-900 sm:leading-[1.1] mb-2 sm:mb-10 uppercase tracking-tight max-w-4xl" data-id="element-37">
              Todo tu año de clases de pádel resuelto{' '}
              <span className="text-blue-700" data-id="element-38">de una vez.</span>
            </h1>

            {/* PRODUCT IMAGE — between H1 and subtitle */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-2 sm:mb-12" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/uploads/idQcamCpECnLCfajXPgUnv/348.png" alt="Megapack PADEL 360 — Elite Bundle con 12 Tomos, 6 Bonus y 2 Ebooks Élite" width="576" height="576" fetchPriority="high" decoding="async" className="w-auto max-h-[38vh] sm:max-h-none sm:w-full sm:max-w-xl mx-auto h-auto drop-shadow-2xl" data-id="element-40" />
            </motion.div>

            <p className="text-base sm:text-2xl text-slate-700 font-medium mb-2 sm:mb-4" data-id="element-41">
              Megapack PADEL 360 — Pack Anual Elite Completo
            </p>

            <p className="hidden sm:block text-lg text-slate-600 mb-8 max-w-lg" data-id="element-42">
              El sistema completo de planificación, drills y secuencias para el
              profesor de pádel argentino.
            </p>

            <div className="hidden sm:flex flex-wrap gap-3 mb-8 justify-center" data-id="element-43">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-200 text-slate-800 rounded-md text-sm font-medium" data-id="element-44">
                📄 PDF
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-200 text-slate-800 rounded-md text-sm font-medium" data-id="element-45">
                ⚡ Acceso Inmediato
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-100 text-yellow-800 rounded-md text-sm font-bold border border-yellow-300" data-id="element-46">
                📚 12 Tomos + 6 Bonus + 2 Élite
              </span>
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white text-base sm:text-xl font-heading font-bold py-3 sm:py-5 px-6 sm:px-8 rounded-xl shadow-xl shadow-blue-600/20 transition-all hover:scale-105 flex items-center justify-center gap-3 uppercase tracking-wide animate-pulse" data-id="element-47">
              💪 QUIERO MI PADEL 360 AHORA
            </button>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm text-slate-500 font-medium" data-id="element-48">
              <span className="flex items-center gap-1.5" data-id="element-49">
                <ShieldCheck className="w-4 h-4 text-blue-600" data-id="element-50" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-51">
                <Lock className="w-4 h-4 text-blue-600" data-id="element-52" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-53">
                <CreditCard className="w-4 h-4 text-blue-600" data-id="element-54" /> Tarjetas y
                transferencia
              </span>
            </div>
          </motion.div>
        </div>

        {/* Trust Badges */}
        <div className="mt-20 pt-10 border-t border-slate-200" data-id="element-55">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-56">
            <div data-id="element-57">
              <p className="text-3xl font-heading font-bold text-slate-900" data-id="element-58">
                +300
              </p>
              <p className="text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-59">
                profes Argentina
              </p>
            </div>
            <div data-id="element-60">
              <p className="text-3xl font-heading font-bold text-slate-900" data-id="element-61">
                12+6
              </p>
              <p className="text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-62">
                Tomos + Bonus
              </p>
            </div>
            <div data-id="element-63">
              <p className="text-3xl font-heading font-bold text-slate-900" data-id="element-64">
                4.9/5
              </p>
              <p className="text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-65">
                calificación
              </p>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-66">
              <div className="flex text-yellow-400 mb-1" data-id="element-67">
                <Star className="w-6 h-6 fill-current" data-id="element-68" />
                <Star className="w-6 h-6 fill-current" data-id="element-69" />
                <Star className="w-6 h-6 fill-current" data-id="element-70" />
                <Star className="w-6 h-6 fill-current" data-id="element-71" />
                <Star className="w-6 h-6 fill-current" data-id="element-72" />
              </div>
              <p className="text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-73">
                MP confían
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 - INITIAL TESTIMONIALS */}
      <section className="py-16 bg-white px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="max-w-7xl mx-auto" data-id="element-75">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-76">
            <TestimonialCard initials="MP" quote="Organicé todo el mes de clases en una tarde. Nunca más llego a la cancha sin saber qué drill voy a dar." name="Martín P., Buenos Aires" role="Profesor de Pádel en Club Privado" data-id="element-77" />
            <TestimonialCard initials="CG" quote="Mis alumnos de nivel inicial mejoraron su posición en cancha desde la primera semana con el Tomo 2. Nunca había visto eso tan rápido." name="Carolina G., Córdoba" role="Profesora de Pádel Independiente" data-id="element-78" />
            <TestimonialCard initials="FR" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo que corresponde y en 5 minutos estoy listo." name="Federico R., Rosario" role="Profesor de Pádel en Academia" data-id="element-79" />
          </div>
        </div>
      </section>

      {/* SECTION 3 - PAIN SECTION */}
      <section className="py-20 bg-blue-950 text-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-80">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-900/40 blur-3xl rounded-full transform translate-x-1/2" data-id="element-81"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-12 text-center" data-id="element-83">
            Si sos profe de pádel, esto te va a sonar conocido:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-84">
            <PainPoint text="Llegás a la cancha sin saber exactamente qué drill vas a dar hoy" data-id="element-85" />
            <PainPoint text="Tus alumnos no progresan porque no hay un orden claro de contenidos" data-id="element-86" />
            <PainPoint text="Tenés grupos con niveles mezclados y no sabés cómo manejarlos" data-id="element-87" />
            <PainPoint text="Un alumno falta 2 semanas y perdés la continuidad de todo el grupo" data-id="element-88" />
            <PainPoint text="No podés justificar una suba de precio porque no tenés nada sistematizado" data-id="element-89" />
            <PainPoint text="El domingo a la noche te agarra la ansiedad sin saber qué dar el lunes" data-id="element-90" />
            <PainPoint text="Repetís los mismos drills una y otra vez porque no tenés más variantes y los alumnos se aburren" data-id="element-91" />
            <PainPoint text="Nadie valora tu trabajo porque no se refleja en un progreso concreto y visible" data-id="element-92" />
          </div>

          <div className="text-center bg-blue-900/50 p-8 rounded-2xl border border-blue-800 backdrop-blur-sm" data-id="element-93">
            <h3 className="text-3xl md:text-4xl font-heading font-bold text-yellow-400 mb-8 italic" data-id="element-94">
              "¿Cuántas clases más vas a improvisar?"
            </h3>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-yellow-500 hover:bg-yellow-400 text-blue-950 text-xl font-heading font-bold py-5 px-8 rounded-xl shadow-xl shadow-yellow-500/20 transition-all hover:scale-105 flex items-center justify-center gap-3 uppercase mx-auto" data-id="element-95">
              👉 BASTA DE IMPROVISAR — QUIERO MI PADEL 360
            </button>
          </div>
        </div>
      </section>
    </div>;
}
function TestimonialCard({
  initials,
  quote,
  name,
  role
}: {
  initials: string;
  quote: string;
  name: string;
  role: string;
}) {
  return <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-96">
      <div className="flex items-center gap-4 mb-6" data-id="element-97">
        <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-bold text-lg" data-id="element-98">
          {initials}
        </div>
        <div className="flex text-yellow-400" data-id="element-99">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-100" />)}
        </div>
      </div>
      <p className="text-slate-700 italic mb-6 text-lg" data-id="element-101">"{quote}"</p>
      <div data-id="element-102">
        <p className="font-bold text-slate-900" data-id="element-103">{name}</p>
        <p className="text-sm text-slate-500" data-id="element-104">{role}</p>
      </div>
    </div>;
}
function PainPoint({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-4 bg-blue-900/40 p-5 rounded-xl border border-blue-800/50" data-id="element-105">
      <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-106" />
      <p className="text-blue-50 text-lg leading-snug" data-id="element-107">{text}</p>
    </div>;
}